import { rateTableSchema } from "@redotech/redo-fulfillment-rate-table-common/rate-table";
import * as z from "zod";

export const saveTeamRateTable = {
  name: "saveTeamRateTable" as const,
  input: z.object({ teamId: z.string(), rateTable: rateTableSchema }),
  output: z.object({ rateTables: z.array(rateTableSchema) }),
};
